module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel_02_bg-e938dabeada827e7bf021967bd7e1717.png";